import { render, staticRenderFns } from "./WsCustomerService.vue?vue&type=template&id=22385654&scoped=true"
import script from "./WsCustomerService.vue?vue&type=script&lang=js"
export * from "./WsCustomerService.vue?vue&type=script&lang=js"
import style0 from "./WsCustomerService.vue?vue&type=style&index=0&id=22385654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22385654",
  null
  
)

export default component.exports